import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { Else } from "./IfThenElse";

interface ElseContainerProps {
    positiveCondition: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: ElseContainerProps) => ({
    visible: !ownProps.processEvaluableProp(state, ownProps.positiveCondition),
});

export const ElseContainer = withResolvePaths(withViewModelSelect(withEvaluators(connect(mapStateToProps)(Else))));
